module.exports = __webpack_public_path__ + "img/1536995692.439106c9.jpg";